import type { CampaignAccent } from "../../data";

// Colours for one example business in the campaign mock-ups, built from the
// theme's tone pairs (the preview used a hex brand colour per business).
//   solid - avatar and email button (carries white text)
//   art   - offer card, email banner and ad artwork (carries ink text)
export const campaignAccentClasses: Record<
  CampaignAccent,
  { solid: string; art: string }
> = {
  brand: {
    solid: "bg-primary",
    art: "bg-linear-135 from-tone-peach to-primary/45 text-ink",
  },
  mint: {
    solid: "bg-tone-mint-ink",
    art: "bg-linear-135 from-tone-mint to-tone-mint-ink/40 text-ink",
  },
  lilac: {
    solid: "bg-tone-lilac-ink",
    art: "bg-linear-135 from-tone-lilac to-tone-lilac-ink/40 text-ink",
  },
  sun: {
    solid: "bg-tone-sun-ink",
    art: "bg-linear-135 from-tone-sun to-tone-sun-ink/40 text-ink",
  },
  sky: {
    solid: "bg-tone-sky-ink",
    art: "bg-linear-135 from-tone-sky to-tone-sky-ink/40 text-ink",
  },
};
